import { useEffect, useRef } from "react";
import { INativeMessage, TNativeMessageFields, TNativeMessagePayload } from "src/lib/native-bridge/define-native-message";
import { NATIVE_EVENT_NAME } from "src/lib/native-bridge/native-message.types";

interface IUseNativeMessageParams<Type extends string, Fields extends TNativeMessageFields> {
    message: INativeMessage<Type, Fields>;
    onMessage: (payload: TNativeMessagePayload<Fields>) => void;
}

export const useNativeMessage = <Type extends string, Fields extends TNativeMessageFields>({
    message,
    onMessage,
}: IUseNativeMessageParams<Type, Fields>) => {
    const onMessageRef = useRef(onMessage);

    useEffect(() => {
        onMessageRef.current = onMessage;
    });

    useEffect(() => {
        const handleNativeEvent = (event: Event) => {
            const payload = message.parse((event as CustomEvent).detail);
            if (!payload) {
                return;
            }

            onMessageRef.current(payload);
        };

        globalThis.addEventListener(NATIVE_EVENT_NAME, handleNativeEvent);

        return () => {
            globalThis.removeEventListener(NATIVE_EVENT_NAME, handleNativeEvent);
        };
    }, [message]);
};
